var render = function render(){
  var _vm$selectedCustomer, _vm$selectedCustomer2, _vm$customerToDelete, _vm$priceToDelete;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:items-stretch gap-4"
  }, [_c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg font-medium",
    class: _vm.activeTab === 'customers' ? 'bg-primary-500 text-white' : 'bg-white text-neutral-700',
    on: {
      "click": function ($event) {
        _vm.activeTab = 'customers';
      }
    }
  }, [_vm._v(" Customers ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg font-medium",
    class: _vm.activeTab === 'prices' ? 'bg-primary-500 text-white' : 'bg-white text-neutral-700',
    attrs: {
      "disabled": !_vm.selectedCustomer
    },
    on: {
      "click": function ($event) {
        return _vm.openPricesTab();
      }
    }
  }, [_vm._v(" Prices ")])]), _c('div', {
    staticClass: "flex-1 mdmax:w-full"
  }, [_vm.activeTab === 'customers' ? _c('div', {
    staticClass: "max-w-lg"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Pencarian ")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari customer..."
    },
    on: {
      "enter": _vm.onSearchCustomers
    },
    model: {
      value: _vm.customerSearch,
      callback: function ($$v) {
        _vm.customerSearch = $$v;
      },
      expression: "customerSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]) : _c('div', {
    staticClass: "max-w-lg"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Destination (Opsional) ")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Filter destination..."
    },
    on: {
      "enter": _vm.onSearchPrices
    },
    model: {
      value: _vm.destinationFilter,
      callback: function ($$v) {
        _vm.destinationFilter = $$v;
      },
      expression: "destinationFilter"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])]), _c('div', {
    staticClass: "flex mdmax:w-full justify-end gap-2"
  }, [_vm.activeTab === 'customers' ? _c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": function ($event) {
        return _vm.openCustomerModal('create');
      }
    }
  }, [_vm._v(" + Tambah Customer ")]) : _c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.selectedCustomer
    },
    on: {
      "click": function ($event) {
        return _vm.openPriceModal('create');
      }
    }
  }, [_vm._v(" + Tambah Price ")])])]), _vm.activeTab === 'customers' ? _c('div', [_c('TableComponent', {
    attrs: {
      "columns": _vm.customerColumns,
      "list": _vm.customerTableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          attrs: {
            "title": "Kelola harga"
          },
          on: {
            "click": function ($event) {
              return _vm.selectCustomer(entry);
            }
          }
        }, [_vm._v(" Prices ")]), _c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          attrs: {
            "title": "Edit"
          },
          on: {
            "click": function ($event) {
              return _vm.openCustomerModal('edit', entry);
            }
          }
        }, [_vm._v(" Edit ")]), _c('button', {
          staticClass: "px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm",
          attrs: {
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.openDeleteCustomerModal(entry);
            }
          }
        }, [_vm._v(" Delete ")])]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'discount_percent' ? _c('span', [_vm._v(" " + _vm._s(entry.discount_percent || "0") + "% ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }], null, false, 4084300911)
  }), _vm.customerTableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.customerStart) + " - " + _vm._s(_vm.customerEnd) + " dari " + _vm._s(_vm.totalCustomers) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.customerPage,
      "totalCount": _vm.totalCustomers,
      "pageSize": _vm.customerPerPage
    },
    on: {
      "onPageChange": _vm.changeCustomerPage
    }
  })], 1) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "bg-white rounded-lg p-4 mb-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-neutral-500 text-sm"
  }, [_vm._v("Selected Customer")]), _c('p', {
    staticClass: "text-neutral-800 font-bold"
  }, [_vm._v(" " + _vm._s(((_vm$selectedCustomer = _vm.selectedCustomer) === null || _vm$selectedCustomer === void 0 ? void 0 : _vm$selectedCustomer.customer_name) || "-") + " ")]), _c('p', {
    staticClass: "text-neutral-500 text-sm"
  }, [_vm._v(" " + _vm._s(((_vm$selectedCustomer2 = _vm.selectedCustomer) === null || _vm$selectedCustomer2 === void 0 ? void 0 : _vm$selectedCustomer2.customer_address) || "-") + " ")])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.priceColumns,
      "list": _vm.priceTableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref2) {
        var _entry$min_weight;

        var entry = _ref2.entry,
            column = _ref2.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          attrs: {
            "title": "Edit"
          },
          on: {
            "click": function ($event) {
              return _vm.openPriceModal('edit', entry);
            }
          }
        }, [_vm._v(" Edit ")]), _c('button', {
          staticClass: "px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm",
          attrs: {
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.openDeletePriceModal(entry);
            }
          }
        }, [_vm._v(" Delete ")])]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'min_weight' ? _c('span', [_vm._v(" " + _vm._s((_entry$min_weight = entry.min_weight) !== null && _entry$min_weight !== void 0 ? _entry$min_weight : 0) + " ")]) : column.field === 'price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.price)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  }), _vm.priceTableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.priceStart) + " - " + _vm._s(_vm.priceEnd) + " dari " + _vm._s(_vm.totalPrices) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.pricePage,
      "totalCount": _vm.totalPrices,
      "pageSize": _vm.pricePerPage
    },
    on: {
      "onPageChange": _vm.changePricePage
    }
  })], 1) : _vm._e()], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.customerModalVisible,
      "width": "960px"
    },
    on: {
      "close": _vm.closeCustomerModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.customerModalMode === "create" ? "Tambah" : "Edit") + " Customer ")]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "md:col-span-2"
  }, [_c('TextField', {
    attrs: {
      "label": "Customer Name",
      "required": "",
      "placeholder": "Nama customer"
    },
    model: {
      value: _vm.customerForm.customer_name,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "customer_name", $$v);
      },
      expression: "customerForm.customer_name"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('TextField', {
    attrs: {
      "label": "NPWP",
      "placeholder": "Masukkan NPWP"
    },
    model: {
      value: _vm.customerForm.npwp,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "npwp", $$v);
      },
      expression: "customerForm.npwp"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('Textarea', {
    attrs: {
      "label": "Customer Address",
      "placeholder": "Alamat customer"
    },
    model: {
      value: _vm.customerForm.customer_address,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "customer_address", $$v);
      },
      expression: "customerForm.customer_address"
    }
  })], 1), _c('div', [_c('TextField', {
    attrs: {
      "label": "PIC Name",
      "placeholder": "Nama PIC"
    },
    model: {
      value: _vm.customerForm.pic_name,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "pic_name", $$v);
      },
      expression: "customerForm.pic_name"
    }
  })], 1), _c('div', [_c('TextField', {
    attrs: {
      "label": "Discount Percent",
      "type": "number",
      "placeholder": "Contoh: 5"
    },
    model: {
      value: _vm.customerForm.discount_percent,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "discount_percent", $$v);
      },
      expression: "customerForm.discount_percent"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('Textarea', {
    attrs: {
      "label": "Payment Terms",
      "placeholder": "Contoh: 14 hari",
      "heightClass": "h-24"
    },
    model: {
      value: _vm.customerForm.payment_terms,
      callback: function ($$v) {
        _vm.$set(_vm.customerForm, "payment_terms", $$v);
      },
      expression: "customerForm.payment_terms"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2 flex items-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customerForm.is_rounded,
      expression: "customerForm.is_rounded"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "id": "is-rounded",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customerForm.is_rounded) ? _vm._i(_vm.customerForm.is_rounded, null) > -1 : _vm.customerForm.is_rounded
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.customerForm.is_rounded,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.customerForm, "is_rounded", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.customerForm, "is_rounded", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.customerForm, "is_rounded", $$c);
        }
      }
    }
  }), _c('label', {
    staticClass: "text-sm text-neutral-700",
    attrs: {
      "for": "is-rounded"
    }
  }, [_vm._v(" Is Rounded ")])])]), _c('div', {
    staticClass: "flex justify-end gap-3 mt-6"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeCustomerModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.customerForm.customer_name
    },
    on: {
      "click": _vm.submitCustomer
    }
  }, [_vm._v(" Simpan ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteCustomerModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteCustomerModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v(" Hapus Customer ")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus customer "), _c('strong', [_vm._v(_vm._s((_vm$customerToDelete = _vm.customerToDelete) === null || _vm$customerToDelete === void 0 ? void 0 : _vm$customerToDelete.customer_name))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteCustomerModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDeleteCustomer
    }
  }, [_vm._v(" Hapus ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.priceModalVisible,
      "width": "520px"
    },
    on: {
      "close": _vm.closePriceModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.priceModalMode === "create" ? "Tambah" : "Edit") + " Price ")]), _c('div', {
    staticClass: "grid grid-cols-1 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Destination",
      "required": "",
      "placeholder": "Contoh: JKT"
    },
    model: {
      value: _vm.priceForm.destination,
      callback: function ($$v) {
        _vm.$set(_vm.priceForm, "destination", $$v);
      },
      expression: "priceForm.destination"
    }
  }), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Min Weight",
      "type": "number",
      "placeholder": "0"
    },
    model: {
      value: _vm.priceForm.min_weight,
      callback: function ($$v) {
        _vm.$set(_vm.priceForm, "min_weight", $$v);
      },
      expression: "priceForm.min_weight"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Price",
      "type": "number",
      "placeholder": "25000"
    },
    model: {
      value: _vm.priceForm.price,
      callback: function ($$v) {
        _vm.$set(_vm.priceForm, "price", $$v);
      },
      expression: "priceForm.price"
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex justify-end gap-3 mt-6"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closePriceModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.priceForm.destination || !_vm.selectedCustomer
    },
    on: {
      "click": _vm.submitPrice
    }
  }, [_vm._v(" Simpan ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deletePriceModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeletePriceModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Price")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus price untuk destination "), _c('strong', [_vm._v(_vm._s((_vm$priceToDelete = _vm.priceToDelete) === null || _vm$priceToDelete === void 0 ? void 0 : _vm$priceToDelete.destination))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeletePriceModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDeletePrice
    }
  }, [_vm._v(" Hapus ")])])])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }